import { object } from 'common/helpers'


export const initialState = {
  isFetching: true,
  products: [],
  colors: [
    {
      id: 1,
      colors: [
        '#845e97',
        '#2663be',
        '#ffffff',
        '#d742bc',
        '#49a7bd',
        '#c52929',
      ],
    },
    {
      id: 2,
      colors: [
        '#845e97',
        '#ec5760',
        '#c52929',
        '#d742bc',
        '#49a7bd',
      ],
    },
    {
      id: 3,
      colors: [
        '#c52929',
        '#d742bc',
        '#e65661',
        '#be2959',
      ],
    },
    {
      id: 4,
      colors: [
        '#846dcd',
        '#49a7bd',
        '#2663c0',
        '#d742bc',
      ],
    },
    {
      id: 5,
      colors: [
        '#d742bc',
        '#ea555d',
        '#be2959',
      ],
    },
    {
      id: 6,
      colors: [
        '#c52929',
        '#d742bc',
        '#e65661',
        '#be2959',
      ],
    },
  ],
  reviewsData: {
    isFetching: false,
    sortBy: 'recent',
    selectedRating: undefined,
    paginationCursor: 0,

    userReview: null,
    count: null,
    rating: {
      average: 0,
      reviewCount: 0,
      reviews: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
    },
    reviews: [],
  },
}

export const setFetching = (state, payload) =>
  (object.setIn(state, [ 'isFetching' ], payload))

export const setProducts = (state, payload) =>
  (object.setIn(state, [ 'products' ], payload))

export const setReviewsFetching = (state, payload) =>
  (object.setIn(state, [ 'reviewsData', 'isFetching' ], payload))

export const setReviews = (state, payload) =>
  (object.update(state, 'reviewsData', (reviewsData) => ({ ...reviewsData, ...payload, isFetching:false })))

export const setReviewVoteFor = (state, { reviewId, replyId, isUseful }) => {
  const { reviews } = state.reviewsData

  // TODO set expertReviewVoteFor
  const reviewIndex = reviews.findIndex((r) => r.id === reviewId)

  if (reviewIndex === -1) {
    return state
  }

  let path

  if (replyId) {
    const { replies } = reviews[reviewIndex]
    const replyIndex = replies.findIndex((r) => r.id === replyId)
    if (replyIndex === -1) {
      return state
    }

    path = [ 'reviewsData', 'reviews', reviewIndex, 'replies', replyIndex ]
  }
  else {
    path = [ 'reviewsData', 'reviews', reviewIndex ]
  }

  return object.updateIn(state, path, (review) => {
    const prevIsUseful = review.isUseful
    const newReview = { ...review, isUseful }

    if (prevIsUseful !== true && isUseful === true) {
      ++newReview.likeCount
    }
    if (prevIsUseful === true && isUseful !== true) {
      --newReview.likeCount
    }
    if (prevIsUseful !== false && isUseful === false) {
      ++newReview.dislikeCount
    }
    if (prevIsUseful === false && isUseful !== false) {
      --newReview.dislikeCount
    }

    return newReview
  })
}

export const setPaginationCursor = (state, payload) =>
  object.setIn(state, [ 'reviewsData', 'paginationCursor' ], payload)

export const setSelectedRating = (state, payload) =>
  object.setIn(state, [ 'reviewsData', 'selectedRating' ], payload)
